import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './HorseDetails.module.scss';
import { useTranslation } from 'react-i18next';
import StableDetails from '../../StableView/StableDetails/StableDetails';
import HorseInfo from '../HorseInfo/HorseInfo';
import ActivateHorse from '../../../components/Modals/ActivateHorseModal/ActivateHorse/ActivateHorse';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import Heading from '../../../components/Typography/Heading/Heading';
import HorseBox from './HorseBox/HorseBox';
import cn from 'classnames';
import CancelIcon from '../../../components/CancelIcon/CancelIcon';
import { setActiveStableButton } from '../../../store/reducers/Stable/tabs';
const HorseDetails = ({ className }) => {
    const { t } = useTranslation();
    const horse = useAppSelector((state) => state.stable.horse);
    const activeStableButton = useAppSelector((state) => state.stableTab.activeStableButton);
    const dispatch = useAppDispatch();
    if (!horse)
        return _jsx(_Fragment, {});
    const parsedData = [
        {
            title: 'Total race',
            amount: 0,
            icon: ''
        },
        {
            title: '1st place',
            amount: 0,
            icon: ''
        },
        {
            title: '2nd place',
            amount: 0,
            icon: ''
        },
        {
            title: '3nd place',
            amount: 0,
            icon: ''
        }
    ];
    const horseData = {
        totalStats: 0,
        speed: 0,
        stamina: 0,
        acceleration: 0,
        endurance: 0,
        agility: 0
    };
    // const raceData = [
    //     {
    //         name: 'Golden Oaks Day Dash',
    //         desc: 'Bergen, NO',
    //         date: '07/04/2022',
    //         distance: '1400m',
    //         place: '3rd'
    //     },
    //     {
    //         name: 'Golden Oaks Day Dash',
    //         desc: 'Bergen, NO',
    //         date: '07/04/2022',
    //         distance: '1400m',
    //         place: '3rd'
    //     },
    //     {
    //         name: 'Golden Oaks Day Dash',
    //         desc: 'Bergen, NO',
    //         date: '07/04/2022',
    //         distance: '1400m',
    //         place: '3rd'
    //     }
    // ];
    // const columns = [
    //     { label: 'name', accessor: 'name' },
    //     { label: 'date', accessor: 'date' },
    //     { label: 'distance', accessor: 'distance' },
    //     { label: 'place', accessor: 'place' }
    // ];
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsx(CancelIcon, { onClick: () => dispatch(setActiveStableButton(!activeStableButton)) }), _jsx(StableDetails, { className: styles.wrapper, detailsTitle: t('career_performance'), data: parsedData }), _jsx(HorseInfo, { additionalBox: true, title: t('training'), desc: t('training_helps_develop_physical_stats'), buttonText: t('edit') }), _jsx(HorseBox, Object.assign({ text: t('breeding') }, { children: _jsx(HorseInfo, { title: t('move_to_breeding'), desc: t('once_a_horse_moves_to_breeding'), buttonText: t('start_breeding') }) })), _jsx(HorseBox, Object.assign({ text: t('pedigree') }, { children: _jsxs("div", Object.assign({ className: styles.pedigree }, { children: [_jsx(Heading, { size: 3, title: t('parents') }), _jsx(ActivateHorse, { className: styles.horsesBox, horseData: horseData, values: { name: 'Parent 1' } }), _jsx(ActivateHorse, { className: styles.horsesBox, horseData: horseData, values: { name: 'Parent 2' } })] })) }))] })));
};
export default HorseDetails;
